// Color palette definitions for word cloud text colors
// Each palette is an array of hex color strings

export const COLOR_PALETTES = [
  {
    name: 'random',
    label: 'Random',
    colors: null // null means random RGB generation (backward compatible)
  },
  {
    name: 'ocean',
    label: 'Ocean',
    colors: [
      '#0077b6', '#023e8a', '#0096c7', '#00b4d8', '#48cae4',
      '#90e0ef', '#03045e', '#0077b6', '#023e8a', '#00b4d8'
    ]
  },
  {
    name: 'sunset',
    label: 'Sunset',
    colors: [
      '#ff6b35', '#f7c59f', '#ef476f', '#ffd166', '#06d6a0',
      '#118ab2', '#073b4c', '#ef476f', '#ff6b35', '#ffd166'
    ]
  },
  {
    name: 'forest',
    label: 'Forest',
    colors: [
      '#2d6a4f', '#40916c', '#52b788', '#74c69d', '#95d5b2',
      '#1b4332', '#081c15', '#2d6a4f', '#40916c', '#52b788'
    ]
  },
  {
    name: 'candy',
    label: 'Candy',
    colors: [
      '#ff99c8', '#fcf6bd', '#d0f4de', '#a9def9', '#e4c1f9',
      '#ff99c8', '#fcf6bd', '#d0f4de', '#a9def9', '#e4c1f9'
    ]
  },
  {
    name: 'vintage',
    label: 'Vintage',
    colors: [
      '#6b4c3a', '#a67c52', '#c9a96e', '#e2c290', '#f4d9a0',
      '#8b5a2b', '#5c3a21', '#6b4c3a', '#a67c52', '#c9a96e'
    ]
  },
  {
    name: 'neon',
    label: 'Neon',
    colors: [
      '#ff006e', '#fb5607', '#ffbe0b', '#3a86ff', '#8338ec',
      '#ff006e', '#fb5607', '#ffbe0b', '#3a86ff', '#8338ec'
    ]
  },
  {
    name: 'midnight',
    label: 'Midnight',
    colors: [
      '#e0aaff', '#c77dff', '#9d4edd', '#7b2cbf', '#5a189a',
      '#3c096c', '#240046', '#9d4edd', '#c77dff', '#e0aaff'
    ]
  },
  {
    name: 'earth',
    label: 'Earth',
    colors: [
      '#d4a373', '#faedcd', '#fefae0', '#ccd5ae', '#e9edc9',
      '#bc6c25', '#606c38', '#283618', '#d4a373', '#ccd5ae'
    ]
  }
];

/**
 * Get a palette by name
 * @param {string} name - palette name
 * @returns {object} palette object with name, label, and colors array (null for random)
 */
export function getPalette(name) {
  return COLOR_PALETTES.find(p => p.name === name) || COLOR_PALETTES[0];
}

/**
 * Create a color function for ECharts textStyle.color
 * @param {Array|null} colors - array of hex colors, or null for random
 * @returns {Function} color function compatible with ECharts
 */
export function createColorFunction(colors) {
  if (!colors || colors.length === 0) {
    // Random mode: generate dark/medium colors
    return () => {
      return 'rgb(' + [
        Math.round(Math.random() * 160),
        Math.round(Math.random() * 160),
        Math.round(Math.random() * 160)
      ].join(',') + ')';
    };
  }
  let idx = 0;
  return () => {
    const color = colors[idx % colors.length];
    idx++;
    return color;
  };
}
